import axiosInstance from "../../translator";

export const getApiDocs = async (urlParams) => {
  return axiosInstance
    .get(`/v1/${urlParams}/schema/`)
    .then((response) => {
      return response;
    })
    .catch((error) => {
      return error;
    });
};
